import { useNavigate } from 'react-router-dom'
import { useContentSearch } from '@/hooks/use-content-search'
import { useMatchCache } from '@/stores/match-cache'
import { DocumentSearchComboboxView } from './DocumentSearchComboboxView'

interface DocumentSearchComboboxProps {
  caseId: string
  value: string
  onChange: (v: string) => void
}

export function DocumentSearchCombobox({ caseId, value, onChange }: DocumentSearchComboboxProps) {
  const navigate = useNavigate()
  const { data, isFetching, isError } = useContentSearch(caseId, value)

  return (
    <DocumentSearchComboboxView
      value={value}
      onChange={onChange}
      results={{ data, isFetching, isError }}
      actions={{
        onOpenDocument: hit => navigate(`/cases/${caseId}/documents?doc=${hit.document_id}`),
        onOpenEntity: hit =>
          navigate(
            `/cases/${caseId}/documents?doc=${hit.document_id}&entity=${encodeURIComponent(hit.entity_id)}&tab=details`
          ),
        onOpenChunk: hit => {
          useMatchCache.getState().setMatch(hit.chunk_id, {
            section: hit.section,
            pageNumber: hit.page_number,
            snippet: hit.snippet,
            query: value,
          })
          navigate(
            `/cases/${caseId}/documents?doc=${hit.document_id}&match_chunk=${encodeURIComponent(hit.chunk_id)}&tab=preview`
          )
        },
      }}
    />
  )
}
